export default {
  devTitle: 'Golden River',
  index: 'Index',
  info: 'Info',

  /* Main 頁面 */
  // 選單
  copyRight: 'Copyright',
  ProductArea: 'PRODUCT AREA',
  BrandConcept: 'BRAND CONCEPT',
  DevelopmentProcess: 'DEVELOPMENT PROCESS',
  TechnicalSupport: 'TECHNICAL SUPPORT',
  contactus: 'CONTACT US',
  copy: 'COPY',
  // footer
  phone: '+886.2.2556.2973',
  email: 'Contact@goldenriver.tech',
  add: '3F., No. 30, Sec. 1, Chongqing N. Rd., Datong Dist., Taipei City 103607 , Taiwan (R.O.C.))',
  /* Index 頁面 */
  more: 'MORE',
  // 介紹萬達區
  readMore: 'READ MORE',
  aboutTitle1: 'ABOUT',
  aboutTitle2: 'Golden River',
  aboutSubtitle: 'VISION AND MISSION',
  aboutContent: 'Golden River aims to transform customer service with cutting-edge AI technology. We focus on creating smart, efficient AI customer service systems to improve interactions and help businesses boost efficiency while cutting costs. Our vision is a smarter, more connected customer service world, enabling seamless, effective communication between businesses and customers.',
  cultureTitle: 'CULTURE AND VALUE',
  cultureSubtitle1: 'GOOD FAITH',
  cultureSubtitle2: 'TEAMWORK',
  cultureSubtitle3: 'NON-STOP INNOVATION',
  cultureContent1: 'Good faith Integrity is the core concept and value of XXX. We firmly believe that in good faith, we treat shareholders, customers, suppliers and employees in good faith, and establish mutual trust, mutual knowledge and mutual assistance with them, and sincerely cooperate to develop mutual benefit.',
  cultureContent2: 'Talent is the most important asset of the enterprise, with the strength of the research and development team, is the key to the success of building services. Golden River pay great attention to the professional growth and self-challenge of each partner, which cultivates the innovative dynamics of continuous learning and growth, and regards communication as the most important ability as professional skills. Our team is composed of partners across a variety of fields, can perfectly supply long-term research and development technology energy for enterprise customers with ambitious mission.',
  cultureContent3: 'Transformation needs times and innovation needs to be implemented within the organization.Golden River Faces a New Era, Redefining Metrics, Find Problems Anytime, Anywhere, Changing habits in order to ""Multi-innovation environment, Enhance competitive advantage"". By understanding the importance of internal and external innovation physique, operating globally, focusing on the future. Product and technical strength first, plus incisive market insight, then be sustainable.',
  // 開發過程區
  devMainTitle: 'DEVELOPMENT PROCESS',
  devSubTitle1: 'CONCEPT DESIGN',
  devSubTitle2: 'DESIGN FOR VERIFICATION',
  devSubTitle3: 'PRODUCT DEVELOPED',
  devSubTitle4: 'SERVICE DISCIPLINE',
  devSubContent1: 'Analysis needs and plan the most suitable solution based on professional technology',
  devSubContent2: 'Validate the development concept of the design, Improve the feasibility of customer needs',
  devSubContent3: 'Specific project teams, independent work teams, Increase flexibility and instant delivery',
  devSubContent4: 'Maintenance as the development team and continuous optimization, Adjust functionality based on your needs',
  // 技術支援區
  tectMainTitle: 'TECHNICAL SUPPORT',
  techIcon1: 'TECHNICAL SUPPORT',
  techIcon2: 'STUDY GUIDE',
  techIcon3: 'USER RIGHTS',

  /* Trade 頁面 */
  platformTitle: 'MULTI-PLATFORM TERMINAL TRADING ANYTIME, ANYWHERE',
  platformSubTitle1: 'IOS, ANDROID, WINDOWS, MAC AND MORE PLATFORMS',
  platformSubTitle2: 'WITH FULL-SERVICE CAPABILITIES ARE SUPPORTED.',
  platIcon1: 'iOS, MAC',
  platIcon2: 'Android',
  platIcon3: 'Windows',
  platIcon4: 'Device',

  /* Wallet 頁面 */
  scopeTitle: 'TECHNICAL SCOPE',
  scopeSubtitle1: 'ENCRYPTED BLUETOOTH CONNECTION',
  scopeSubtitle2: 'EAL CERTIFIED SAFETY COMPONENTS',
  scopeSubtitle3: 'TRADING FUNCTION',
  scopeContent1: 'Encrypted Bluetooth connectivity for Android and iOS for the most convenient mobile experience.',
  scopeContent2: 'Get a safe view of your portfolio and trade with secure cold storage technology. ',
  scopeContent3: 'Support for Binance DEX, WalletConnect, token exchange, and a variety of enhancements to help accelerate support for DeFi communications agreements, NFT collectibles, DApps, and other emerging products and services.',
  featureTitle: 'PRODUCT FEATURES',
  featureSubTitle1: 'INSTANT EXCHANGE',
  featureSubTitle2: 'USER-FRIENDLY CREATION AND IMPORT PROCESS',
  featureSubTitle3: 'USERS CAN EASILY MANAGE MULTI-CHAIN ASSETS',
  featureSubTitle4: 'STATE-OF-THE-ART TECHNOLOGY TO PROTECT YOUR ASSETS',
  featureSubTitle5: 'SECURE STORAGE ',
  featureContent1: 'NO FORMS, NO SELFIES. EASILY TRADE CRYPTOCURRENCIES AT ANY TIME.',
  featureContent2: 'USER-FRIENDLY UX. EASILY VIEW AND ACCESS ENCRYPTED BALANCES.',
  featureContent3: 'MORE THAN 20 WALLET TYPES ARE ALSO SUPPORTED: BTC、ETH、HECO、DOGE、XRP、DOT、KSM、BCH、LTC、ETC、TRX、 XTZ、EOS、ATOM、BCH',
  featureContent4: 'CONTROL 100% OF THE PRIVATE KEYS THAT THEY SECURELY STORE ON YOUR DEVICE ',
  featureContent5: 'YOUR KEYS ARE PROTECTED BY SECURE ENCLAVE, BIOMETRIC AUTHENTICATION, AND OPTIONAL CLOUD BACKUPS',
  // 置底用
  aaa: 'aaa',
  // 漢堡選單
  'HOME PAGE': 'HOME PAGE',
  'PRODUCT AREA': 'PRODUCT AREA',
  CURRENCY: 'CURRENCY',
  'BRAND CONCEPT': 'BRAND CONCEPT',
  'DEVELOPMENT PROCESS': 'DEVELOPMENT PROCESS',
  'TECHNICAL SUPPORT': 'TECHNICAL SUPPORT'
}
